export const environment = {
  production: false,
  apiUrl: 'https://ksat-dev.teleperformancecn.com/api',
  msalConfig: {
    auth: {
      clientId: 'ea78ac77-436c-4b58-86fa-ee5f6b34aedc',
      authority: 'https://login.microsoftonline.com/638fcbaf-ba4c-43e1-adae-5475c970fe10',
      redirectUri: 'https://ksat-dev.teleperformancecn.com/auth/redirect',
      postLogoutRedirectUri: 'https://ksat-dev.teleperformancecn.com/auth/login',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  backendConfig: {
    scopes: ['api://ea78ac77-436c-4b58-86fa-ee5f6b34aedc/access_as_user'],
    uri: 'https://ksat-dev.teleperformancecn.com/api',
  },
};
